import React from "react";
//icons
import PlusIcon from "assets/icons/plus.svg";
import MinusIcon from "assets/icons/minus.svg";
//mui
import { Typography, Stack, Button, Box } from "@mui/material";
//components
import { SvgIconStyle } from "components";

import useCart from "../store";
import { useTranslation } from "react-i18next";

export default function CommonCounter({
	count,
	setCount,
	item,
	max,
	isCart,
	sx,
}) {
	const { cart, removeCart, increaseCart, decreaseCart } = useCart(
		(state) => state
	);

	const { t } = useTranslation();
	const onIncrease = () => {
		if (isCart) {
			// 장바구니
			if (!max) {
				return null;
			} else {
				return item.buyCount >= max ? alert(t("over-max")) : increaseCart(item);
			}
		} else {
			// 상품 상세
			if (!max) {
				return null;
			} else {
				count >= max ? null : setCount(count + 1);
			}
		}
	};
	const onDecrease = () => {
		setCount ? setCount(count <= 1 ? 1 : count - 1) : null;
		if (isCart) {
			if (count - 1 == 0) return removeCart(item);
			decreaseCart(item);
		}
	};

	const increaseDisabled = () => {
		const limit = item.salesLimitOnce
			? item.qty
			: Math.min(...[item.qty, item.salesLimitOnce]);
		return !!limit && item.buyCount == limit;
	};

	return (
		<Box sx={{ ...sx }}>
			<Stack direction="row" gap={4}>
				<Button
					onClick={onDecrease}
					disabled={count === 1}
					sx={{
						width: 45,
						height: 45,
						border: "1px solid #D9D9D9",
						borderRadius: "100%",
						"&.Mui-disabled": {
              background:'#E0E0E0',
              opacity: 0.7,
						},
					}}
				>
					<SvgIconStyle src={MinusIcon} size={20} sx={{ color: "grey.dark" }} />
				</Button>

				<Typography variant="body2" fontSize={28}width={45} textAlign={'center'}>
					{count}
				</Typography>

				<Button
					onClick={onIncrease}
					disabled={isCart ? increaseDisabled() : !max || count >= max}
					sx={{
						width: 45,
						height: 45,
						border: "1px solid #D9D9D9",
						borderRadius: "100%",

						"&.Mui-disabled": {
							span: {
								opacity: 0.3,
							},
						},
					}}
				>
					<SvgIconStyle src={PlusIcon} size={20} sx={{ color: "grey.dark" }} />
				</Button>
			</Stack>
		</Box>
	);
}
